import { SelectionWithNoteSourceCitationMixin } from './mixin';
import { SelectionAny } from './internal';
export class SelectionNamePieces extends SelectionWithNoteSourceCitationMixin(SelectionAny) {
    getPrefixName() {
        return this.get("NPFX" /* Tag.NamePrefix */);
    }
    getGivenName() {
        return this.get("GIVN" /* Tag.GivenName */);
    }
    getNickname() {
        return this.get("NICK" /* Tag.Nickname */);
    }
    getPrefixSurname() {
        return this.get("SPFX" /* Tag.SurnamePrefix */);
    }
    getSurname() {
        return this.get("SURN" /* Tag.Surname */);
    }
    getNameSuffix() {
        return this.get("NSFX" /* Tag.NameSuffix */);
    }
}
//# sourceMappingURL=SelectionNamePieces.js.map